<ng-container *ngIf="curriculumUnit">
  <div class="exp" [ngClass]=AppConfig.theme>
    <div class="hgroup" >
      <h4>{{ curriculumUnit.title }}</h4>
      <h6 class="mt-2">
        <i class="fa fa-calendar" aria-hidden="true"></i>
        {{ curriculumUnit.date }}
      </h6>
    </div>
    <p [innerHtml]="curriculumUnit.content">
    </p>
  </div>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-curriculum/syllabus-curriculum.component.html